<template>
  <div class="dynamic-list">
    <HomeList
      v-if="isShowList"
      :paramsKey="paramsKey"
      :getListApi="getDynamicList"
      :params="homeListParams"
      @getList="getList"
    >
      <template>
        <TopicItem
          ref="topicItems"
          v-for="(item, index) in dynamicList"
          :key="index"
          :index="index"
          :topic="item"
          :token="token"
          :isGoUserIndex="false"
          :isShowFocus="false"
          :isShowMore="false"
          @openImgViewrt="openImgViewrt"
          @goGroupDes="goGroupDes"
          @goTopicDetail="goTopicDetail"
          @goDes="goDes"
          @handleClick="topciItemHandle"
          @toTagPage="toTagPage"
        ></TopicItem>
      </template>
    </HomeList>
    <!-- 图片预览 -->
    <img-viewer
      :config="imgViewerConfig"
      @close="closeImgViewrt"
      @appDownloadImgCallback="appDownloadImgCallback"
    />
  </div>
</template>

<script>
import HomeList from 'component/platform/homepage/common/homeList.vue'
import TopicItem from 'component/platform/topicDetail/topicItem.vue'
import imgViewer from 'component/common/imgViewer'
import homepageMixin from 'mixins/platfrom/homepageMixin.js'
export default {
  name: 'dynamicList',
  props: {},
  mixins: [homepageMixin],
  components: {
    HomeList,
    TopicItem,
    imgViewer
  },
  data() {
    return {
      token: '',
      paramsKey: {
        pageNo: 'pageNo',
        pageSize: 'pageSize',
        listPath: 'list'
      },
      imgViewerConfig: {
        show: false,
        index: 0,
        list: [],
        zoom: true
      },
      homeListParams: {},
      isShowList: false
    }
  },
  computed: {
    dynamicList() {
      return this.$store.getters['homepage/getDynamicListData'] || []
    }
  },
  created() {},
  mounted() {
    // 获取token, 再发起请求
    this.mixinGetToken().then(token => {
      this.token = token
      this.homeListParams = {
        userId: this.$route.params.userId,
        objectType: 1,
        token: token
      }
      this.isShowList = true
    })
  },
  methods: {
    getDynamicList(params) {
      return this.$store.dispatch('homepage/fetchDynamicList', params)
    },
    goGroupDes() {
      this.$trackEvent('newprofilepages_dynamic_group', {})
    },
    goTopicDetail() {
      this.$trackEvent('newprofilepages_dynamic_topic', {})
    },
    // 跳转到动态详情
    goDes(item, index) {
      this.$trackEvent('newprofilepages_dynamic_click', {})
      const { objectId, objectType } = item.baseContentVo
      this.clickItem = {
        objectId,
        objectType,
        index
      }
      this.routerPushWithoutNav(
        `/dynamicDetail/${item.baseContentVo.objectId}?node=1`
      )
    },
    // 点击操作栏，全部跳转到动态详情
    topciItemHandle({ params, index }) {
      this.goDes(params, index)
    },
    // 打开图片预览弹窗
    openImgViewrt(data, index) {
      this.imgViewerConfig.show = true
      this.imgViewerConfig.list = data
      this.imgViewerConfig.index = index
    },
    // 关闭图片预览弹窗
    closeImgViewrt() {
      this.imgViewerConfig.show = false
    },
    // 图片保存成功回调
    appDownloadImgCallback() {
      console.log('图片保存成功')
    },
    // 查看关联群任务埋点回调
    toTagPage(info, other) {
      if (+info?.dataObject?.tagType === 2) {
        this.$trackEvent('newprofilepages_dynamic_grouptask', {
          task_name: info.dataObject.tagName,
          group_id: info.dataObject.groupId
        })
      } else if (info === 'tail') {
        this.$trackEvent('newprofilepages_dynamic_cards', {
          content_title: other.title
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dynamic-list {
  margin-top: 30px;
}
</style>
